import styled from 'styled-components';

import { ItemRuleProps } from './types';

export const ListRules = styled.ul`
  margin-top: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const ItemRule = styled.li`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const ValidationBullet = styled.div<ItemRuleProps>`
  height: 8px;
  width: 8px;
  border: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme, valid }) => {
      return valid
        ? theme.yoga.colors.feedback.success.dark
        : theme.yoga.colors.text.secondary;
    }};
  border-radius: ${({ theme }) => theme.yoga.radii.regular}px;
  background-color: ${({ theme, valid }) => {
    return valid
      ? theme.yoga.colors.feedback.success.dark
      : theme.yoga.colors.white;
  }};
`;

export const Rule = styled.p<ItemRuleProps>`
  font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
  margin-left: ${({ theme }) => theme.yoga.spacing.small}px;
  color: ${({ theme, valid }) => {
    return valid
      ? theme.yoga.colors.feedback.success.dark
      : theme.yoga.colors.text.secondary;
  }};
`;

export const ResendEmailContainer = styled.div`
  text-align: center;
  margin-top: ${({ theme }) => theme.yoga.spacing.medium}px;
`;
